import { render, staticRenderFns } from "./ImgDragSort.vue?vue&type=template&id=2933ffa3&scoped=true&"
import script from "./ImgDragSort.vue?vue&type=script&lang=js&"
export * from "./ImgDragSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2933ffa3",
  null
  
)

export default component.exports